module.exports = __webpack_public_path__ + "img/icon_download.04935712.svg";